// extracted by mini-css-extract-plugin
export default {"dataRow":"fustlist_dataRow__Ssib9"};